import {
  PostAttributionUsersTypeaheadResponseType,
  PostAttributionPartnersTypeaheadResponseType,
} from './types';

export const transformUsersTypeaheadResponse = (
  requestData: PostAttributionUsersTypeaheadResponseType
) => {
  return requestData.records;
};

export const transformPartnersTypeaheadResponse = (
  requestData: PostAttributionPartnersTypeaheadResponseType
) => {
  return requestData.records;
};
